var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 80H80C82.1217 80 84.1566 79.1571 85.6569 77.6569C87.1571 76.1566 88 74.1217 88 72V32C88 29.8783 87.1571 27.8434 85.6569 26.3431C84.1566 24.8429 82.1217 24 80 24H48.28C46.9623 23.9932 45.6668 23.661 44.5084 23.033C43.35 22.4049 42.3647 21.5005 41.64 20.4L38.36 15.6C37.6353 14.4995 36.65 13.5951 35.4916 12.967C34.3332 12.339 33.0377 12.0068 31.72 12H16C13.8783 12 11.8434 12.8429 10.3431 14.3431C8.84285 15.8434 8 17.8783 8 20V72C8 76.4 11.6 80 16 80Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFolder;